import React from "react";

import LoginContent from "./LoginContent";

import { CardContent, Grid, Card, Typography } from "@material-ui/core";

import { useTranslation } from "react-i18next";

export default function LoginPage() {
  const { t } = useTranslation();
  
  return (
    <Grid
      container
      spacing={0}
      align="center"
      justify="center"
      direction="column"
      style={{ height: "100%" }}
    >
      <Grid container justify="center" direction="row">
        <Grid item md={3} xs={12}>
          <Card p={3}>
            <CardContent>
              <Typography gutterBottom variant="h5" component="h2">
                {t("login.title")}
              </Typography>

              <LoginContent/>

            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Grid>
  );
}
